/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  SAVE,
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_DAMAGED_LOST_EXPENSE,
  RESET_DELAYED_LUGGAGE_EXPENSE,
  RESET_COMPENSATION,
} from './constants';

export function saveFormData(form) {
  return {
    type: SAVE,
    payload: form,
  };
}

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function nextSlide(errors) {
  return {
    type: NEXT,
    errors,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function resetDelayedExpenseFormData() {
  return {
    type: RESET_DELAYED_LUGGAGE_EXPENSE,
  };
}

export function resetDamagedLostExpenseFormData() {
  return {
    type: RESET_DAMAGED_LOST_EXPENSE,
  };
}

export function resetFormCompensationExpense() {
  return {
    type: RESET_COMPENSATION,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PersonalItemStep/actions.js